export default "__VITE_ASSET__DKm_muAa__"